import React from 'react';

import { BrowserRouter, Routes,
  Route } from 'react-router-dom';


import Jim from './Components/Jim2.js'
function App() {
  return (
    <BrowserRouter>
   
    <Routes>
    <Route path="/" element={<Jim />} />
   
   
    </Routes>
    </BrowserRouter>
  );
}

export default App;
